import React, { Component } from "react";
import firebase from "firebase/app";
import { withRouter } from "react-router-dom";
import Input from "../Components/Input/Input.base";
import Button from "../Components/Button/Button.base";

const style = {
  marginTop: "100px",
  button: { margin: "50px" }
};

class pitchEditor extends Component {
  state = {
    title: this.props.location.state.video.title,
    description: this.props.location.state.video.description
  };

  updateSpeech = () => {
    const video = this.props.location.state.video;
    const { title, description } = this.state;

    firebase
      .database()
      .ref(`/videos/${video.id}`)
      .update({ title, description });
    this.props.history.push("/pitchs");
  };

  handleChange = (e) => {
    let stateName = e.target.name.toLowerCase();
    this.setState({ [stateName]: e.target.value });
  };

  confirmSuppr = () => {
    const video = this.props.location.state.video;
    let confirm = prompt(
      "Attention cette action est irréversible, si vous êtes vraiment sûr de vouloir supprimer votre pitch, inscrivez son titre et validez. "
    );
    confirm === video.title && this.handleSuppr();
  };

  handleSuppr = () => {
    const video = this.props.location.state.video;
    firebase
      .database()
      .ref(`/videos/${video.id}`)
      .remove();
    this.props.history.push("/pitchs");
  };

  render() {
    const video = this.props.location.state.video;
    return (
      <div style={style}>
        <h1>Modification de {video.title}</h1>

        <Input
          type="text"
          value={this.state.title}
          label="Title"
          onChange={(e) => this.handleChange(e)}
          maxLength="40"
          style={style.input}
        />
        <Input
          type="text"
          value={this.state.description}
          label="Description"
          onChange={(e) => this.handleChange(e)}
          maxLength="140"
          multiline
          rowsMax={3}
          style={style.input}
        />
        <br />
        <Button
          width="150"
          variant="outlined"
          label="Annuler"
          color="default"
          style={style.button}
          onClick={() => this.props.history.push("/pitchs")}
        />
        <Button
          width="150"
          variant="outlined"
          type="submit"
          label="Valider"
          onClick={() => this.updateSpeech()}
          style={style.button}
        />

        <Button
          width="150"
          variant="outlined"
          label="Supprimer mon pitch"
          color="secondary"
          onClick={() => this.confirmSuppr()}
          style={style.button}
        />
      </div>
    );
  }
}
export default withRouter(pitchEditor);
